import { combinedStyleSelector, TargetSelector } from "@client/selectors";

export const makeImageStyleSelector = () =>
  combinedStyleSelector(TargetSelector.Entity, ["border", "boxShadow"], "image");
